/**
 * Format a date or timestamp as a human-readable date and time.
 * Uses Intl.DateTimeFormat to avoid a date-fns dependency.
 * @param date - Date object or ISO string
 * @returns Formatted string like "Feb 14, 2026 at 1:30 PM"
 */
export const formatDateTime = (date: Date | string): string => {
  const d = new Date(date);

  const datePart = new Intl.DateTimeFormat('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(d);

  const timePart = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  }).format(d);

  return `${datePart} at ${timePart}`;
};
